import { XAxisType } from '../types';
import { Dropdown } from '@carbon/react';

// ---------------------------------------------------------------------------
// X-Axis Switcher component (standalone, can be passed into VolumeChart2)
// ---------------------------------------------------------------------------

// Single source of truth for the x-axis dropdown labels. Charts read this so
// the exported x-axis title matches the option selected in the switcher.
export const X_AXIS_TYPE_LABELS: Record<XAxisType, string> = {
  date: 'Date',
  count: 'Months Online',
  cumulativeOil: 'Cumulative Oil',
  cumulativeWater: 'Cumulative Water',
  cumulativeGas: 'Cumulative Gas',
  materialBalanceTimeOil: 'Material Balance Time Oil',
  materialBalanceTimeWater: 'Material Balance Time Water',
  materialBalanceTimeGas: 'Material Balance Time Gas',
};

export interface XAxisSwitcherProps {
  chartType: 'monthly' | 'logarithmic' | 'cumulative' | 'ratio';
  value: XAxisType;
  onChange: (value: XAxisType) => void;
  className?: string;
  excludeOptions?: XAxisType[];
  direction?: 'top' | 'bottom';
}

export const XAxisSwitcher = ({
  chartType,
  value,
  onChange,
  className,
  excludeOptions,
  direction,
}: XAxisSwitcherProps) => {
  let options = (
    [
      ...(chartType !== 'logarithmic' ? ['date'] : []),
      'count',
      'cumulativeOil',
      'cumulativeWater',
      'cumulativeGas',
      'materialBalanceTimeOil',
      'materialBalanceTimeWater',
      'materialBalanceTimeGas',
    ] as XAxisType[]
  ).map((id) => ({ id, text: X_AXIS_TYPE_LABELS[id] }));

  if (excludeOptions) {
    options = options.filter(
      (o) => !excludeOptions.includes(o.id as XAxisType)
    );
  }

  const selected = options.find((o) => o.id === value);

  return (
    <Dropdown
      id="x-axis-type"
      titleText=""
      size="sm"
      direction={direction}
      items={options}
      itemToString={(item) => (item ? item.text : '')}
      label={selected?.text || 'Select X-Axis'}
      selectedItem={selected}
      onChange={({ selectedItem }) => {
        if (selectedItem) onChange(selectedItem.id as XAxisType);
      }}
      className={className}
    />
  );
};
